<ng-container *ngIf="!isHidden">
    <se-floating-label *ngIf="control?.isWithLabel" [for]="control.id">{{ control?.name }}</se-floating-label>
    <map-loading *ngIf="isLoading; else loaded">{{ "mapLoadingPlaceholder" | translate}}...</map-loading>
    <ng-template #loaded>
        <map-container [containerConfig]="containerConfig"
                        [legendColors]="colorLegend"
                        [data]="colorData"
                        [segmentLabelType]="control.segmentLabelType"
                        [readOnly]="isMapDisabled"
                        [buttonsConfiguration]="control.legendActionsConfiguration"
                        [isHorizontal]="control.isHorizontal"
                        [isWithTooltip]="control.isWithTooltip"
                        [isWithViewId]="control.isWithViewId"
                        [viewTopLabel]="_viewTopLabel"
                        [viewBottomLabel]="_viewBottomLabel"
                        [fixedColumnNumber]="control.fixedViewsColNumber"
                        [configuredRowNumber]="control.rowSpan">
            <ng-container extra-buttons-legend>
                <cp-additional-content *ngFor="let additionalContent of control.additionalContent"
                    [control]="additionalContent"
                    [cardId]="cardId"
                    [disabled]="isMapDisabled">
                </cp-additional-content>
            </ng-container>
        </map-container>
    </ng-template>
</ng-container>
